// Widget Scripts
import featureLineUp from "./js/featureLineUp.js";

// Custom Theme Scripts
import "./js/localjs.js";

// Initialize Homepage Widgets if is required
$(document).ready(function () {
  if (window.location.pathname !== "/") {
    featureLineUp();
  }
});
